import React from 'react';
import { CTAButton } from './CTAButton';
import { plans } from '../data/content';
export function PricingSection() {
  return <section id="precios" className="w-full bg-ink-800 px-4 py-14 sm:px-5 sm:py-20" style={{
    paddingTop: "0px",
    paddingBottom: "0px",
    paddingLeft: "0px",
    paddingRight: "0px"
  }} data-id="element-163" data-mp="19jxenin1zhdz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-164" data-mp="1j973mpmlojxv">
        <h2 className="text-2xl font-extrabold uppercase text-white sm:text-4xl" data-id="element-165" data-mp="1jas1op84il0h">
          💰 Elegí tu sistema
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2" style={{
        marginTop: "0px",
        gap: "2px",
        height: "665px"
      }} data-id="element-166" data-mp="1s9403df8en3h">
          {plans.map(plan => <article key={plan.name} className={`relative flex flex-col rounded-3xl border p-6 text-left sm:p-7 ${plan.featured ? 'border-brand-500 bg-ink-900 shadow-[0_0_45px_rgba(249,115,22,0.25)]' : 'border-white/10 bg-ink-900'}`} style={{
          width: "338px",
          height: "326px"
        }} data-id="element-167" data-mp="1xa1fji8ux31a">
              {plan.featured && <span className="absolute -top-3 left-6 rounded-full bg-brand-500 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-ink-900" data-id="element-168" data-mp="7ul8q9ientek">
                  ⭐ Más elegido
                </span>}
              <h3 className="text-base font-extrabold text-white sm:text-lg" data-id="element-169" data-mp="1hon5tyzt60z2">
                <span aria-hidden="true" data-id="element-170" data-mp="1crn05p6vf08h">{plan.icon}</span> {plan.name}
              </h3>
              <p className="mt-3 text-sm text-gray-300" data-id="element-171" data-mp="17stl3sbxr167">{plan.includes}</p>
              <p className="mt-2 text-sm text-gray-400" data-id="element-172" data-mp="25fafoptab0o9">
                <span className="font-semibold text-brand-500" data-id="element-173" data-mp="25er73zpixomw">Ideal para:</span>{' '}
                {plan.idealFor}
              </p>

              <p className="mt-6 text-sm font-semibold text-gray-500 line-through" data-id="element-174" data-mp="1vh312dmgwupf">
                Valor real: {plan.oldPrice}
              </p>
              <p className="text-3xl font-extrabold text-brand-500 sm:text-4xl" data-id="element-175" data-mp="1rf81peo3krea">
                {plan.price}
              </p>

              <div className="mt-auto pt-7" style={{
            paddingTop: "2px"
          }} data-id="element-176" data-mp="jzux1tfqhgls">
                <CTAButton href={plan.href} variant={plan.featured ? 'primary' : 'outline'} data-id="element-177" data-mp="fzazior90az4">
                  {plan.cta}
                </CTAButton>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}